import { AccordionDetails as MuiAccordionDetails } from '@mui/material';
import * as React from 'react';
import { TAccordionDetails } from './AccordionDetails.types';
import './Accordion.styles.scss';

export const AccordionDetails: TAccordionDetails = (props) => {
  return <MuiAccordionDetails className="accordion-details" {...props} />;
};
